const pageBackground = "#FBFCFD";

export const fallbackValues = {
  pageBackground
};
